import { TranslationService } from "@/core/services/TranslationService";
import FormDatamodel from "@/views/form/views/FormDatamodel.vue";
import FormSite from "@/views/form/views/FormSite.vue";
import FormEvent from "@/views/form/views/FormEvent.vue";
import FormUser from "@/views/form/views/FormUser.vue";
import FormActivity from "@/views/form/views/FormActivity.vue";
import FormDetail from "@/views/form/views/FormDetail.vue";
import SectionDetail from "@/views/form/views/SectionDetail.vue";
import { IDataTableFilterOption } from "@/interfaces/iPageModel";
import { boolean } from "yup";
export function formTableHeaders() {
  return [
    {
      name: TranslationService.translate("pages.form.formName"),
      key: "name",
      sortable: true,
    },
    // {
    //   name: TranslationService.translate("pages.form.frequency"),
    //   key: "frequencyCodeText",
    // },
    {
      name: TranslationService.translate("pages.form.locationRestriction"),
      key: "locationRestrict",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
    // {
    //   name: TranslationService.translate("common.sequence"),
    //   key: "sequence",
    //   attrs: {
    //     class: "vz-dataTable-center",
    //   },
    // },
    {
      name: TranslationService.translate("common.startDate"),
      key: "startDate",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.endDate"),
      key: "endDate",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.status"),
      key: "status",
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
    {
      name: "",
      key: "clone",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function formTableFilters() {
  return [
    {
      key: "formDefinitionIds",
      label: TranslationService.translate("pages.form.title"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "forms/filter/FORM_NAME",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "startDate",
      label: TranslationService.translate("common.dateRange"),
      type: "datetimerange",
    },
    {
      key: "status",
      label: TranslationService.translate("common.status"),
      type: "select",
      options: [
        { label: TranslationService.translate("common.all"), value: "" },
        {
          label: TranslationService.translate("common.active"),
          value: "ACTIVE",
        },
        {
          label: TranslationService.translate("common.inactive"),
          value: "INACTIVE",
        },
      ],
    },
    {
      key: "locationRestrict",
      label: TranslationService.translate("pages.form.locationRestriction"),
      type: "checkboxes",
    },
  ];
}

export function formTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "definitions",
    entityLabel: TranslationService.translate("common.forms"),
  };
}

export function FormDataModelTableHeaders() {
  return [
    {
      name: TranslationService.translate("common.name"),
      key: "name",
    },
    {
      name: TranslationService.translate("common.startDate"),
      key: "startDate",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.endDate"),
      key: "endDate",
      sortable: true,
    },
    {
      name: TranslationService.translate("pages.form.locationCode"),
      key: "locationCode",
      sortable: true,
    },
    {
      name: TranslationService.translate("pages.form.sequence"),
      key: "sequence",
    },
    {
      name: TranslationService.translate("pages.form.recordHistory"),
      key: "recordHistory",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
    {
      name: TranslationService.translate("pages.form.locationRestriction"),
      key: "locationRestriction",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
    {
      name: TranslationService.translate("common.status"),
      key: "status",
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function FormDataModelTableFilters() {
  return [
    {
      key: "lookupIds",
      label: TranslationService.translate("pages.form.title"),
      type: "autocomplete",
      attrs: { mode: "tags" },
      options: [
        { label: "All", value: "" },
        { label: "Active", value: "ACTIVE" },
        { label: "Inactive", value: "INACTIVE" },
      ],
    },
    {
      key: "status",
      label: TranslationService.translate("common.status"),
      type: "select",
      options: [
        { label: TranslationService.translate("common.all"), value: "null" },
        {
          label: TranslationService.translate("common.active"),
          value: "ACTIVE",
        },
        {
          label: TranslationService.translate("common.inactive"),
          value: "INACTIVE",
        },
      ],
    },
    {
      key: "createdDate",
      label: TranslationService.translate("common.createdDate"),
      type: "date",
    },
  ];
}

export function FormDataModelTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "definitions",
    entityLabel: TranslationService.translate("pages.form.title"),
  };
}

export function FormSiteTableHeaders() {
  return [
    {
      name: TranslationService.translate("pages.form.siteNumber"),
      key: "code",
      sortable: true,
    },
    {
      name: TranslationService.translate("pages.form.siteName"),
      key: "name",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.assignedDate"),
      key: "assignDate",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.status"),
      key: "status",
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function FormSiteTableFilters() {
  return [
    {
      key: "filterSiteIds",
      label: TranslationService.translate("common.sites"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "site/filter/SITES",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "startDate",
      label: TranslationService.translate("common.dateRange"),
      type: "datetimerange",
    },
  ];
}

export function FormCategoryTableHeaders() {
  return [
    {
      name: TranslationService.translate("pages.form.categoryCode"),
      key: "categoryCode",
    },
    {
      name: TranslationService.translate("pages.form.formName"),
      key: "formName",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.status"),
      key: "status",
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function FormCategoryTableFilters() {
  return [
    {
      key: "categoryCode",
      label: TranslationService.translate("pages.form.formCategory"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "static-data/filter/LOOKUP_FILTER/filters?filter[lookupName]=LKFormsCategory",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "status",
      label: TranslationService.translate("common.status"),
      type: "select",
      options: [
        { label: TranslationService.translate("common.all"), value: "null" },
        {
          label: TranslationService.translate("common.active"),
          value: "ACTIVE",
        },
        {
          label: TranslationService.translate("common.inactive"),
          value: "INACTIVE",
        },
      ],
    },
  ];
}

export function FormEmailRoutingTableHeaders() {
  return [
    {
      name: TranslationService.translate("pages.form.emailRoutingCode"),
      key: "emailRoutingCode",
    },
    {
      name: TranslationService.translate("common.createdDate"),
      key: "createdDate",
    },
    {
      name: TranslationService.translate("pages.form.formName"),
      key: "formName",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function FormEmailRoutingTableFilters() {
  return [];
}

export function FormUserEmailRoutingTableHeaders() {
  return [
    {
      name: TranslationService.translate("pages.form.externalEmail"),
      key: "externalEmail",
    },
    {
      name: TranslationService.translate("common.createdDate"),
      key: "createdDate",
    },
    {
      name: TranslationService.translate("pages.form.formName"),
      key: "formName",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function FormUserEmailRoutingTableFilters() {
  return [];
}

export function FormRoleEmailRoutingTableHeaders() {
  return [
    {
      name: TranslationService.translate("pages.form.roleCode"),
      key: "roleCode",
    },
    {
      name: TranslationService.translate("common.createdDate"),
      key: "createdDate",
    },
    {
      name: TranslationService.translate("pages.form.formName"),
      key: "formName",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function FormRoleEmailRoutingTableFilters() {
  return [];
}

export function FormUserEmailRoutingTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "definitions",
    entityLabel: TranslationService.translate("pages.form.title"),
  };
}

export function FormRoleEmailRoutingTableBulkDelete() {
  return {
    showDelete: true,
    key: "webIds",
    entity: "definitions",
    entityLabel: TranslationService.translate("pages.form.title"),
  };
}

export function FormEmailRoutingTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "definitions",
    entityLabel: TranslationService.translate("pages.form.title"),
  };
}

export function FormSiteTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "definitions",
    entityLabel: TranslationService.translate("common.sites"),
  };
}

export function FormCategoryTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "definitions",
    entityLabel: TranslationService.translate("pages.form.title"),
  };
}

export function formSectionsTableHeaders() {
  return [
    {
      name: TranslationService.translate("pages.form.sectionName"),
      key: "name",
    },
    // {
    //   name: TranslationService.translate("pages.form.recordHistory"),
    //   key: "recordHistory",
    //   attrs: {
    //     class: "vz-dataTable-center",
    //   },
    // },
    {
      name: TranslationService.translate("common.startDate"),
      key: "startDate",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.endDate"),
      key: "endDate",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.status"),
      key: "status",
      sortable: true,
    },
    {
      name: TranslationService.translate("Design"),
      key: "formDesign",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
    {
      name: TranslationService.translate("common.designPreview"),
      key: "designPreview",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function formSectionsTableFilters(): IDataTableFilterOption[] {
  return [
    {
      key: "formSectionIds",
      label: TranslationService.translate("pages.form.sections"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "forms/filter/FORM_SECTION",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "startDate",
      label: TranslationService.translate("common.dateRange"),
      type: "datetimerange",
    },
    // {
    //   key: "userIds",
    //   label: TranslationService.translate("common.users"),
    //   type: "lookup",
    //   attrs: {
    //     mode: "tags",
    //   },
    //   url: "security/filter/USERS",
    //   textKey: "text",
    //   valueKey: "value",
    // },
    {
      key: "status",
      label: TranslationService.translate("common.status"),
      type: "select",
      options: [
        { label: TranslationService.translate("common.all"), value: "" },
        {
          label: TranslationService.translate("common.active"),
          value: "ACTIVE",
        },
        {
          label: TranslationService.translate("common.inactive"),
          value: "INACTIVE",
        },
      ],
    },
  ];
}

export function formActivityTableHeaders() {
  return [
    {
      name: TranslationService.translate("common.dateTime"),
      key: "createdDate",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.user"),
      key: "createdBy",
      sortable: true,
    },
    // {
    //   name: TranslationService.translate("common.type"),
    //   key: "typeCodeText",
    //   sortable: false,
    // },
    {
      name: TranslationService.translate("common.event"),
      key: "descriptions",
      sortable: false,
      attrs: {
        class: "vz-dataTable-left",
      },
    },
  ];
}

export function formActivityTableFilters(): IDataTableFilterOption[] {
  return [
    {
      key: "startDate",
      label: TranslationService.translate("common.dateRange"),
      type: "datetimerange",
    },
    {
      key: "userIds",
      label: TranslationService.translate("common.users"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "security/filter/USERS",
      textKey: "text",
      valueKey: "value",
    },
  ];
}

export function formUserTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "formUsers",
    entityLabel: TranslationService.translate("pages.form.assignUserAndRole"),
  };
}

export function formUserTableHeaders() {
  return [
    {
      name: TranslationService.translate("common.usersRoles"),
      key: "assignment",
      sortable: true,
      sortingField: "assignment",
    },
    {
      name: TranslationService.translate("common.siteName"),
      key: "siteName",
    },
    {
      name: TranslationService.translate("common.assignedDate"),
      key: "createdDate",
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function formUserTableFilters() {
  return [
    {
      key: "userIds",
      label: TranslationService.translate("common.users"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "site/userSites/filter/USERS",
      textKey: "text",
      valueKey: "value",
    },
  ];
}

export function formSectionsTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "sections",
    entityLabel: TranslationService.translate("common.sections"),
  };
}

export function formEventTableHeaders() {
  return [
    {
      name: TranslationService.translate("common.eventName"),
      key: "eventName",
    },
    {
      name: TranslationService.translate("common.siteName"),
      key: "siteName",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.usersRoles"),
      key: "assignment",
    },
    {
      name: TranslationService.translate("common.assignedDate"),
      key: "assignDate",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.status"),
      key: "status",
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function formEventTableFilters() {
  return [
    {
      key: "eventIds",
      label: TranslationService.translate("common.events"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "notification/filter/EVENTS?siteIds=123456",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "filterSiteIds",
      label: TranslationService.translate("common.sites"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "site/filter/SITES",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "status",
      label: TranslationService.translate("common.status"),
      type: "select",
      options: [
        { label: TranslationService.translate("common.all"), value: "" },
        {
          label: TranslationService.translate("common.active"),
          value: "ACTIVE",
        },
        {
          label: TranslationService.translate("common.inactive"),
          value: "INACTIVE",
        },
      ],
    },
  ];
}

export function formEventTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "lookupsData",
    entityLabel: TranslationService.translate("common.events"),
  };
}

export const USER_ROLE_LOOKUP = {
  url: "static-data/filter/LOOKUP_FILTER/filters?filter[lookupName]=LKUserRole",
  textKey: "text",
  valueKey: "value",
};

export const EMAIL_ROUTING_LOOKUP = {
  url: "static-data/filter/LOOKUP_FILTER/filters?filter[lookupName]=LKEmailRouting",
  textKey: "text",
  valueKey: "value",
};

export const CATEGORY_CODE_LOOKUP = {
  url: "static-data/filter/LOOKUP_FILTER/filters?filter[lookupName]=LKFormsCategory",
  textKey: "text",
  valueKey: "value",
};

export const EVENT_LOOKUP = {
  url: "notification/filter/EVENTS?siteIds=123456",
  textKey: "text",
  valueKey: "value",
};

export const USERS_LOOKUP = {
  url: "security/userAccounts?status=ACTIVE",
  textKey: "text",
  valueKey: "value",
};

export function FORM_TABS() {
  return [
    {
      title: TranslationService.translate("pages.form.detail"),
      name: "form.detail",
      icon: "bi bi-card-text me-2 fs-4 text-primary",
      component: FormDetail,
      props: {
        data: {},
      },
    },
    {
      title: TranslationService.translate("pages.form.sites"),
      name: "form.sites",
      icon: "bi bi-diagram-3 me-2 fs-4 text-primary",
      component: FormSite,
      props: {
        data: {},
        openDrawer: boolean,
      },
    },
    {
      title: TranslationService.translate("pages.form.sections"),
      name: "form.sections",
      icon: "bi bi-list-stars me-2 fs-4 text-primary",
      component: FormDatamodel,
      props: {
        data: {},
      },
    },
    {
      title: TranslationService.translate("pages.form.usersRoles"),
      name: "form.users",
      icon: "bi bi-people me-2 fs-4 text-primary",
      component: FormUser,
      props: {
        data: {},
        openDrawer: boolean,
      },
    },
    {
      title: TranslationService.translate("common.events"),
      name: "form.events",
      icon: "las la-business-time me-2 fs-4 text-primary",
      component: FormEvent,
      props: {
        data: {},
        openDrawer: boolean,
      },
    },
    {
      title: TranslationService.translate("common.activity"),
      name: "form.activity",
      icon: "bi bi-signpost-2 me-2 fs-4 text-primary",
      component: FormActivity,
      props: {
        data: {},
      },
    },
  ];
}

export function SECTIONS_TABS() {
  return [
    {
      title: TranslationService.translate("pages.form.detail"),
      name: "section.detail",
      icon: "bi bi-card-text me-2 fs-4 text-primary",
      component: SectionDetail,
      props: {
        data: {},
      },
    },
  ];
}
